import { h } from "preact";
import { useLocation } from "react-router";

import AppFooter from "../components/AppFooter.jsx";
import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";
import Button from "../components/Button.jsx";
import EmptyState from "../components/EmptyState.jsx";

import i18n from "../i18n.js";

export default function ProjectAccessDenied() {
  const location = useLocation();
  return (
    <AppLayout
      header={
        <AppHeader
          title={i18n.t("pages.titles.projects")}
          filterBar={
            <Button
              small
              iconFront="add"
              to={`/projects/add?backTo=${location.pathname}`}
            >
              {i18n.t("pages.projects.createButton")}
            </Button>
          }
        />
      }
      footer={<AppFooter />}
    >
      <EmptyState
        icon="forbidden"
        title={i18n.t("pages.projects.access_denied.title")}
        description={i18n.t("pages.projects.access_denied.description")}
      />
    </AppLayout>
  );
}
